// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"_d7e70bb6","image":"_29bf5082","wrapper":"_840b81f6","name":"_f8e4cc22","arrow":"_1e647efc"};